export default {
  featuredExperiences: 'Unsere hervorgehobenen Erlebnisse',
  searchAllExperiences: 'Alle Erlebnisse suchen',
  searchAll: 'Alles suchen',
  groupSize: 'Gruppengröße',
  eventSize: 'Veranstaltungsgröße',
  upTo: 'Bis zu',
  whatWeDo: 'Was wir machen werden',
  hostedBy: 'Veranstaltet von',
  whatsIncluded: 'Was ist enthalten',
  avail: 'Verfügbarkeit',
  whereWeAre: 'Wo wir sein werden',
  experienceCalendar: 'Erlebniskalender',
  experienceCancelled: 'Erlebnis storniert',
  experienceStartingPrice: 'Ab {{price}}',
  experienceTotalPrice: 'Gesamt {{price}}',
  at: 'bei',
  viewPrivateSessAvailability: 'Verfügbarkeit privater Sitzungen anzeigen',
  selectSession: 'Sitzung auswählen',
  sessionsCount: '{{count}} Zeiten — Zeit wählen',
  noAvailability: 'Keine Verfügbarkeit',
  select: 'Auswählen',
  slotLeft: '{{remainSlots}} Platz übrig',
  slotsLeft: '{{remainSlots}} Plätze übrig',
  spotsLeft: '{{count}} übrig',
  spotsLeftAriaLabel: '{{count}} Plätze verfügbar',
  bookExperience: 'Erlebnis buchen',
  book: 'Buchen',
  learnMore: 'Mehr erfahren',
  apply: 'Anwenden',
  maxPartySizes: 'Maximal {{maxGroupSize}} Plätze pro Gruppe',
  maxPartySize: 'Maximal {{maxGroupSize}} Platz pro Gruppe',
  selectSessionValidation: 'Bitte Sitzung auswählen',
  selectParticipantValidation: 'Bitte Teilnehmer auswählen',
  selectDateValidation: 'Bitte Datum auswählen',
  reminders: 'Erinnerungen',
  seeOtherDates: 'Andere Daten anzeigen',
  location: 'Standort',
  about: 'Über',
  allExperiences: 'Alle Erlebnisse',
  soldOut: 'Ausverkauft',
  reviews: 'Bewertungen',
  reviewSingular: 'Bewertung',
  reviewPlural: 'Bewertungen',
  dateOfExperience: 'Datum des Erlebnisses',
  readLess: 'Weniger lesen',
  readMore: 'Mehr lesen',
  seeMore: 'Mehr sehen',
  details: 'Details',
  durationHour: 'Stunde',
  durationHours: 'Stunden',
  durationMinutes: 'Min.',
  theFollowingVideoDoesNotContainAnyAudio:
    'Das folgende Video enthält keinen Ton',
  by: 'Von',
  chooseATime: 'Zeit für {{title}} wählen',
  amenities: 'Ausstattung',
  ticketSalesOpenIn: 'Ticketverkauf beginnt in',
  ticketSalesOpen: 'Ticketverkauf geöffnet',
  ticketSalesCloseIn: 'Ticketverkauf endet in',
  ticketSalesClose: 'Ticketverkauf geschlossen',
  ticketSalesClosed: 'Ticketverkauf beendet',
  comingSoon: 'Demnächst verfügbar',
  inPartnershipWith: 'In Partnerschaft mit',
  notFoundExperienceTitle: 'Dieses Erlebnis ist nicht mehr verfügbar',
  notFoundExperienceSubtitle:
    'Es wurde möglicherweise unveröffentlicht oder der Link ist nicht mehr gültig.',
  deadLinkRecoverySubtitle:
    'Entdecken Sie weitere Erlebnisse, die Sie buchen können',
  viewAllExperiences: 'Alle Erlebnisse anzeigen',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>Sammeln Sie 5 Basispunkte</strong> für jeden anrechenbaren US-Dollar, wenn Sie sich bei Ihrem World of Hyatt Konto anmelden, um dieses Erlebnis zu buchen</p>',
      basePoints:
        '<p><strong>Sammeln Sie 10 Basispunkte</strong> für jeden anrechenbaren US-Dollar, wenn Sie sich bei Ihrem World of Hyatt Konto anmelden, um dieses Erlebnis zu buchen</p>',
      additionalBonusPoints:
        '<p><strong>Sammeln Sie zusätzlich 4 Bonuspunkte</strong> für jeden anrechenbaren ausgegebenen US-Dollar, wenn Sie mit Ihrer World of Hyatt Kreditkarte buchen</p>',
      additionalBonusPointsTier:
        '<p><strong>Sammeln Sie bis zu 30% zusätzliche Bonuspunkte</strong> je nach Mitgliedsstatus</p>',
      payWithPoints:
        '<p><strong>Zahlen Sie mit Punkten,</strong> wenn Sie dieses Erlebnis buchen</p>',
    },
  },
};
